import type { RequestModel, UpdateRequestStateModel, UpdateRequestStatusModel } from './model/requestModel'
import { requestConstants } from '@/models/constants'
import Net from '@/services/net'
import utils from '@/services/utils'

/**
 * Get list of seasonless requests
 * @param requestState request state
 * @returns RequestModel[]
 */
export function getSeasonlessRequests(filterRequestObject: Record<string, any>, page?: number, pageSize?: number) {
  const params = new URLSearchParams()
  params.set('requestversion', requestConstants.requestVersion.toString())
  if (utils.isDefined(page)) {
    params.set('page', page.toString())
  }
  if (utils.isDefined(pageSize)) {
    params.set('pageSize', pageSize.toString())
  }
  return Net.t1.post<RequestModel[]>(`/requests?${params.toString()}`, filterRequestObject)
}

export function updateSeasonlessRequestStatuses(payload: UpdateRequestStatusModel[]) {
  return Net.t1.put(`/requests/status`, payload)
}

export function updateSeasonlessRequestsState(payload: UpdateRequestStateModel[]) {
  return Net.t1.put(`/requests/states`, payload)
}
